import { useState } from "react";
import { FieldValues, Path, PathValue, useFormContext } from "react-hook-form";
import { GoogleMapsModal } from "./GoogleMapsModal";
import { GMapsLatLng } from "./GMapsLatLng";

export function useGoogleMapsModal<T extends FieldValues>(latField: Path<T>, lngField: Path<T>) {
  const {
    getValues,
    setValue,
    trigger,
    formState: { disabled: isFormDisabled },
  } = useFormContext<T>();

  const [isGoogleMapsModalOpen, setIsGoogleMapsModalOpen] = useState(false);

  const updateCoordinates = (selectedCoordinates: GMapsLatLng) => {
    setValue(latField, selectedCoordinates.lat as PathValue<T, Path<T>>, {
      shouldDirty: true,
    });
    setValue(lngField, selectedCoordinates.lng as PathValue<T, Path<T>>, {
      shouldDirty: true,
    });
  };

  const values = getValues();
  return {
    openGoogleMapsModal: () => setIsGoogleMapsModalOpen(true),
    googleMapsModal: (
      <GoogleMapsModal
        open={isGoogleMapsModalOpen}
        setOpen={() => setIsGoogleMapsModalOpen(false)}
        coordinates={{
          lat: Number(String(values[latField]).trim()),
          lng: Number(String(values[lngField]).trim()),
        }}
        updateCoordinates={updateCoordinates}
        onClose={() => trigger()}
        isMarkerDraggable={!isFormDisabled}
      />
    ),
  };
}
